module.exports = __webpack_public_path__ + "static/media/noData.d8e75e04.svg";